/**
 * English Translations - Base Language
 */

import { TranslationStrings } from "../types";

export const en: TranslationStrings = {
  appName: "HydroLife",
  
  nav: {
    home: "Home",
    settings: "Settings",
    profile: "Profile",
  },
  
  greeting: {
    morning: "Good morning",
    afternoon: "Good afternoon",
    evening: "Good evening",
  },
  
  hydration: {
    glasses: "glasses",
    glass: "glass",
    of: "of",
    goal: "goal",
    addGlass: "Add Glass",
    addExtraGlass: "Add Extra Glass",
    todayProgress: "Today's Progress",
    dailyGoal: "Daily Goal",
    complete: "Complete!",
  },
  
  stats: {
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    weeklyAverage: "Weekly Average",
    streak: "Streak",
    points: "Points",
    day: "day",
    days: "days",
    vsYesterday: "vs yesterday",
    weeklyStats: "Weekly Stats",
  },
  
  achievements: {
    title: "Achievements",
    badges: "Badges",
    progress: "Your Progress",
    unlocked: "Unlocked",
    upNext: "Up next",
    viewAll: "View all",
    showLess: "Show less",
  },
  
  settings: {
    title: "Settings",
    dailyGoal: "Daily Goal",
    reminders: "Reminders",
    hydrationReminders: "Hydration Reminders",
    account: "Account",
    signOut: "Sign Out",
    guestAccount: "Guest account",
    dangerZone: "Danger Zone",
    deleteAccount: "Delete Account",
    deleteAccountDesc: "Permanently delete all your data including profile, hydration history, and badges.",
    language: "Language",
    appLanguage: "App Language",
    localLanguage: "Local Language",
    localLanguageDesc: "Optional dialect for messages & reminders",
    chooseLanguage: "Choose Language",
    useDeviceLanguage: "Use device language",
    searchLanguages: "Search languages...",
  },
  
  onboarding: {
    welcome: "Welcome",
    skip: "Skip",
    next: "Next",
    startTracking: "Start Tracking",
    chooseLanguage: "Choose Your Language",
    selectLanguageDesc: "Select your preferred language for the app",
    screen1Title: "Stay hydrated, stay healthy 💧",
    screen1Subtitle: "HydroLife helps you track your daily water intake with gentle reminders and satisfying progress.",
    screen2Title: "Track every glass",
    screen2Subtitle: "Tap the button each time you drink water. It's that simple.",
    screen3Title: "Build lasting habits",
    screen3Subtitle: "Build streaks, earn points, and stay consistent. Small sips lead to big changes.",
  },
  
  notifications: {
    enable: "Enable Notifications",
    enabled: "Notifications Enabled",
    disabled: "Notifications Disabled",
    permissionTitle: "Stay on Track",
    permissionDesc: "Enable notifications to receive gentle hydration reminders throughout the day.",
    reminderTitle: "Hydration Reminder",
    reminderDesc: "Time to drink some water!",
  },
  
  actions: {
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    done: "Done",
    enable: "Enable",
    disable: "Disable",
    close: "Close",
  },
  
  common: {
    loading: "Loading...",
    error: "Something went wrong",
    success: "Success!",
    retry: "Retry",
    optional: "Optional",
  },
};
